export default __webpack_public_path__ + "static/media/gift.580d9d3e.svg";